/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { AccessRoutes } from 'ui/organisms/AccessRoutes/AccessRoutes';

import { DataDictionaryCatalog } from 'landing-pages/data-dictionary/sections/DataDictionaryCatalog/DataDictionaryCatalog';
import { DataDictionaryHero } from 'landing-pages/data-dictionary/sections/DataDictionaryHero/DataDictionaryHero';

import styles from './DataDictionaryPage.module.scss';

import { getAccessRoutes } from './DataDictionaryPage.data';

export const DataDictionaryPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <DataDictionaryHero />
      <DataDictionaryCatalog />
      <AccessRoutes
        id="how-to-access-the-data"
        background="light"
        heading={t('How to access the data.')}
        lede={t('Seven routes into the same primary, government-sourced dataset. Pick the one that fits your stack.')}
        routes={getAccessRoutes(t)}
      />
    </div>
  );
};
